import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

const ImageViewer = () => {
    const location = useLocation();
    const { imageSrc } = location.state || {}; // Retrieve the image source from the state

    // Extract the image file name from the imageSrc
    const imageName = imageSrc ? imageSrc.split('/').pop() : 'No Image';

    // Update the document title when the component loads
    useEffect(() => {
        document.title = imageName; // Set the page title to the image name
        return () => {
            document.title = 'The Sol Ring'; // Reset the title when leaving the page
        };
    }, [imageName]);

    if (!imageSrc) {
        return (
            <div className="container text-center mt-5">
                <h1 className="display-4">No Image Selected</h1>
                <Link to="/gallery" className="btn btn-primary mt-4">
                    Back to Gallery
                </Link>
            </div>
        );
    }

    return (
        <div className="container text-center mt-5">
            <h1 className="display-4">{imageName}</h1>
            <div className="image-container mt-4">
                <img
                    src={imageSrc}
                    alt={imageName}
                    className="img-fluid"
                    style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                />
            </div>
            <Link to="/gallery" className="btn btn-primary mt-4">
                Back to Gallery
            </Link>
        </div>
    );
};

export default ImageViewer;